import * as yup from 'yup';

export const schema = yup
  .object({
    des_usuario: yup.string().required(),
    email: yup.string().email().required(),
  })
  .required();
